import { render } from "./CommentSidebar.vue?vue&type=template&id=58fd0b1a"
import script from "./CommentSidebar.vue?vue&type=script&lang=js"
export * from "./CommentSidebar.vue?vue&type=script&lang=js"

import "./CommentSidebar.vue?vue&type=style&index=0&id=58fd0b1a&lang=scss"

import exportComponent from "/Users/luke/Documents/contility/server/src/views/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__